/**
 * Event bridge interface for services to publish events without tight coupling
 * to the controller's @Publish decorator
 */
export interface ServiceEventBridge {
	/**
	 * Publish an event to the controller
	 * @param noun The noun (subject) of the event
	 * @param action The action that occurred
	 * @param payload Optional payload data
	 */
	publish(noun: string, action: string, payload?: any): void;
}

/**
 * Base service class that provides event bridge functionality
 * Services can extend this to get event publishing capabilities
 */
export abstract class ServiceBase {
	protected eventBridge?: ServiceEventBridge;

	/**
	 * Set the event bridge for this service
	 * @param bridge The event bridge instance
	 */
	setEventBridge(bridge: ServiceEventBridge): void {
		this.eventBridge = bridge;
	}

	/**
	 * Publish an event through the event bridge
	 * @param noun The noun (subject) of the event
	 * @param action The action that occurred
	 * @param payload Optional payload data
	 */
	protected publish(noun: string, action: string, payload?: any): void {
		this.eventBridge?.publish(noun, action, payload);
	}

	/**
	 * Check if event bridge is available
	 * @returns True if event bridge is set
	 */
	protected hasEventBridge(): boolean {
		return this.eventBridge !== undefined;
	}
}
